import type { RequestedFile } from 'api';
import type { RequestedFileFulfillmentStatus } from 'common/types/files/files';
import { isRequestedFileFulfilled } from 'common/types/files/files';

export type OnboardingRequestedFile = RequestedFile & {
  fulfillment_status?: RequestedFileFulfillmentStatus;
  fulfillment_note?: string | null;
  is_fulfilled?: boolean;
};

export const isOnboardingDocumentFulfilled = (requestedFile?: OnboardingRequestedFile | null): boolean => {
  if (!requestedFile) {
    return false;
  }
  return isRequestedFileFulfilled({
    is_uploaded: requestedFile.is_uploaded,
    is_fulfilled: requestedFile.is_fulfilled,
    fulfillment_status: requestedFile.fulfillment_status,
    files: requestedFile.files,
  });
};

export const isOnboardingDocumentMarkedNa = (requestedFile?: OnboardingRequestedFile | null): boolean =>
  requestedFile?.fulfillment_status === 'not_applicable'
  || requestedFile?.fulfillment_status === 'not_available';

export const getOnboardingFulfillmentSuffix = (
  fulfillmentStatus?: RequestedFileFulfillmentStatus,
  hasUpload = false
): string => {
  if (fulfillmentStatus === 'not_applicable') {
    return ' (N/A)';
  }
  if (fulfillmentStatus === 'not_available') {
    return ' (not available)';
  }
  if (hasUpload) {
    return ' (uploaded)';
  }
  return '';
};
